module.exports = __webpack_public_path__ + "img/image84.920f4206.jpg";